import * as moment from 'moment';

import { LegSummary } from './leg-summary.model';
import { ScheduledFlights_IsHide } from './trip-save.model';

export class TripSummary {
  $id: string = String(Date.now());
  postedAircraftTripId?: number;
  scheduledAircraftTripId?: number;
  customTripId?: string;
  aircraftProfileId: number;
  canVerify: boolean;
  isVerified: boolean;
  verifiedDate: moment.Moment | null;
  verifiedByUserName: string | null;
  tripNotes: string | null;
  display: boolean;
  legs: LegSummary[] = [];
  purposeNotes: string | null;
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  isUserSigned: boolean;
  scheduledFlights_IsHide: ScheduledFlights_IsHide[] = [];
}
